import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Clock, ChevronRight, Loader2 } from "lucide-react";
import MobileAppLayout from "@/components/app/MobileAppLayout";
import { useAppMode } from "@/hooks/useAppMode";
import { useServices } from "@/hooks/useServices";

const AppBook = () => {
  const navigate = useNavigate();
  const { provider } = useAppMode();
  const { data: services = [], isLoading } = useServices(provider?.id);

  const brandColor = provider?.brand_primary_color || undefined;

  return (
    <MobileAppLayout title="Book a session">
      <div className="px-4 py-5">
        <h1 className="text-2xl font-bold tracking-tight mb-1">
          Choose a service
        </h1>
        <p className="text-sm text-muted-foreground mb-5">
          Select what you'd like to book.
        </p>

        {isLoading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : services.length === 0 ? (
          <Card>
            <CardContent className="p-6 text-center text-sm text-muted-foreground">
              No services available right now.
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-3">
            {services.map((service) => (
              <Card
                key={service.id}
                className="overflow-hidden cursor-pointer active:scale-[0.99] transition-transform"
                onClick={() =>
                  navigate(`/app/book/${provider?.id}/${service.id}`)
                }
              >
                {service.image_url && (
                  <div className="h-32 w-full overflow-hidden bg-muted">
                    <img
                      src={service.image_url}
                      alt={service.name}
                      className="h-full w-full object-cover"
                    />
                  </div>
                )}
                <CardContent className="p-4">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <h3 className="font-semibold leading-tight">{service.name}</h3>
                    <span
                      className="font-semibold whitespace-nowrap"
                      style={brandColor ? { color: brandColor } : undefined}
                    >
                      £{Number(service.price).toFixed(2)}
                    </span>
                  </div>
                  {service.description && (
                    <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                      {service.description}
                    </p>
                  )}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-xs text-muted-foreground">
                      <Clock className="h-3 w-3 mr-1" />
                      {service.duration_minutes} min
                    </div>
                    <div
                      className="flex items-center text-sm font-medium"
                      style={brandColor ? { color: brandColor } : undefined}
                    >
                      Book
                      <ChevronRight className="h-4 w-4 ml-0.5" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </MobileAppLayout>
  );
};

export default AppBook;
